import { getGtmConfig } from './gtmConfig';

const injectedIds = new Set();

export function injectGTM(gtmId) {
  if (!gtmId || injectedIds.has(gtmId)) return;
  injectedIds.add(gtmId);

  (function (w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
    const f = d.getElementsByTagName(s)[0];
    const j = d.createElement(s);
    const dl = l !== 'dataLayer' ? '&l=' + l : '';
    j.async = true;
    j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
    f.parentNode.insertBefore(j, f);
  })(window, document, 'script', 'dataLayer', gtmId);

  const noscript = document.createElement('noscript');
  const iframe = document.createElement('iframe');
  iframe.src = `https://www.googletagmanager.com/ns.html?id=${gtmId}`;
  iframe.height = '0';
  iframe.width = '0';
  iframe.style.display = 'none';
  iframe.style.visibility = 'hidden';
  noscript.appendChild(iframe);
  document.body.insertBefore(noscript, document.body.firstChild);
}

export function injectGtag(tagId) {
  if (!tagId || injectedIds.has(tagId)) return;
  injectedIds.add(tagId);

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${tagId}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  window.gtag = gtag;
  gtag('js', new Date());
  gtag('config', tagId);
}

export function injectTagForUniv(univId) {
  const cfg = getGtmConfig(univId);
  if (!cfg) return;
  const list = Array.isArray(cfg) ? cfg : [cfg];
  list.forEach((c) => {
    if (!c || !c.id) return;
    if (c.type === 'gtag') {
      injectGtag(c.id);
    } else {
      injectGTM(c.id);
    }
  });
}
